import { FC, ReactElement, useEffect } from 'react'

import { CacheBuster } from '@/containers'
import { fetchAppVersions } from '@/redux/app/appActions'
import { useTypedDispatch, useTypedSelector } from '@/store'

export const ConnectedCacheBuster: FC = (): ReactElement => {
    const dispatch = useTypedDispatch()

    const currentVersion = useTypedSelector(state => state.appReducer.currentVersion)
    const latestVersion = useTypedSelector(state => state.appReducer.latestVersion)

    useEffect((): void => {
        if (! currentVersion || ! latestVersion) {
            dispatch(fetchAppVersions())
        }
    }, [])

    return (
        <CacheBuster
            currentVersion={currentVersion}
            latestVersion={latestVersion}
        />
    )
}
